
export const neighbourhoodSelectorSGroups = [
    "neighbourhood_read",
    "neighbourhood_read_municipality",
    "municipality_read",
    "municipality_read_state",
    "state_read"
];
